/**
 * Lucide-Icon als Inline-SVG, erbt die Textfarbe. Nur Icons aus der Liste des Design-Systems
 * (Assets › Icons) plus wenige Ergänzungen; `label` nur, wenn das Icon allein steht.
 */
import {
  Archive, Banknote, Bell, CalendarDays, Camera, Check, ChevronLeft, ChevronRight, CircleAlert, CircleCheck, CircleQuestionMark, Clock, Copy,
  Delete, Euro, FileText, Filter, ImageOff, Info, LayoutDashboard, Library, List, LoaderCircle, Lock, LogOut, Mail, Minus, Moon, Package,
  Pencil, Percent, Plus, Printer, QrCode, Receipt, ScanBarcode, ScanLine, Search, Settings, ShoppingBasket, Sparkles, Store, Sun, Tag,
  Trash2, TriangleAlert, Undo2, User, Users, X, Inbox, ShieldCheck, Circle, Wallet, CreditCard,
  type LucideIcon,
} from "lucide-react";

export const ICONS = {
  archive: Archive, banknote: Banknote, bell: Bell, "calendar-days": CalendarDays, camera: Camera, check: Check, "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight, "circle-alert": CircleAlert, "circle-check": CircleCheck, "circle-help": CircleQuestionMark, clock: Clock,
  copy: Copy, delete: Delete, euro: Euro, "file-text": FileText, filter: Filter, "image-off": ImageOff, info: Info,
  "layout-dashboard": LayoutDashboard, library: Library, list: List, "loader-circle": LoaderCircle, lock: Lock, "log-out": LogOut, mail: Mail,
  minus: Minus, moon: Moon, package: Package, pencil: Pencil, percent: Percent, plus: Plus, printer: Printer, "qr-code": QrCode, receipt: Receipt,
  "scan-barcode": ScanBarcode, "scan-line": ScanLine, search: Search, settings: Settings, "shopping-basket": ShoppingBasket, sparkles: Sparkles,
  store: Store, sun: Sun, tag: Tag, "trash-2": Trash2, "triangle-alert": TriangleAlert, "undo-2": Undo2, user: User, users: Users, x: X,
  inbox: Inbox, "shield-check": ShieldCheck, circle: Circle, wallet: Wallet, "credit-card": CreditCard,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export interface IconProps {
  name: IconName;
  size?: number;
  /** Nur setzen, wenn das Icon allein steht (ohne Text daneben). */
  label?: string;
  strokeWidth?: number;
  className?: string;
}

export function Icon({ name, size = 24, label, strokeWidth = 2, className }: IconProps) {
  const Comp = ICONS[name];
  return (
    <Comp
      className={["rg-icon", className].filter(Boolean).join(" ")}
      size={size}
      strokeWidth={strokeWidth}
      aria-hidden={label ? undefined : true}
      role={label ? "img" : undefined}
      aria-label={label}
      focusable={false}
    />
  );
}
